class mobile_insurance {
    constructor() {
      const WEBDOCHANDSETINSDAILY1 = "WEBDOCHANDSETINSDAILY1";
      const WEBDOCHANDSETINSDAILY2 = "WEBDOCHANDSETINSDAILY2";
      const WEBDOCHANDSETINSDAILY3 = "WEBDOCHANDSETINSDAILY3";

      this.items = [
        {
          serviceId: 1,
          pid: WEBDOCHANDSETINSDAILY1,
          name: "WebdocHandsetInsDaily1",
          serviceName:"Handset Insurance",
          badge: "Basic",
          coverage: "10,000",
          price:"4.5",
          bgColorClass: "bg-info",
          description: `<p><strong>Mobile Insurance:</strong> Insurance is an exciting product that provides good value to Jazz customers who get financial protection in case of mobile screen breakage or burglary!</p>
<p><strong>Coverage: </strong>All-Inclusive Security: Rest easy with excellent coverage against:</p>
<ul>
<li><strong>Total Insurance Cover: </strong>PKR 10,000</li>
<li><strong>Waiting Period:</strong> 14 days</li>
</ul>
<p><strong>Claims:</strong></p>
<ul>
<li>Make your claim within 30 (thirty) days of the damage or theft/burglary</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>End-to-end support and handholding to claimant</li>
<li>Claim will be settled on market value of the phone screen repair of same make and model</li>
</ul>
`,
          type: "insurance",
        },
        {
          serviceId: 2,
          pid: WEBDOCHANDSETINSDAILY2,
          name: "WebdocHandsetInsDaily2",
          serviceName:"Handset Insurance",
          badge: "Gold",
          coverage: "20,000",
          price:"9.0",
          bgColorClass: "bg-warning",
          description: `<p><strong>Mobile Insurance:</strong> Insurance is an exciting product that provides good value to Jazz customers who get financial protection in case of mobile screen breakage or burglary!</p>
<p><strong>Coverage: </strong>All-Inclusive Security: Rest easy with excellent coverage against:</p>
<ul>
<li><strong>Total Insurance Cover: </strong>PKR 20,000</li>
<li><strong>Waiting Period:</strong> 14 days</li>
</ul>
<p><strong>Claims:</strong></p>
<ul>
<li>Make your claim within 30 (thirty) days of the damage or theft/burglary</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>End-to-end support and handholding to claimant</li>
<li>Claim will be settled on market value of the phone screen repair of same make and model</li>
</ul>`,
          type: "insurance",
        },
        {
          serviceId: 3,
          pid: WEBDOCHANDSETINSDAILY3,
          name: "WebdocHandsetInsDaily3",
          serviceName:"Handset Insurance",
          badge: "Platinum",
          coverage: "30,000",
          price:"13.5",
          bgColorClass: "bg-info",
          description: `<p><strong>Mobile Insurance:</strong> Insurance is an exciting product that provides good value to Jazz customers who get financial protection in case of mobile screen breakage or burglary!</p>
<p><strong>Coverage: </strong>All-Inclusive Security: Rest easy with excellent coverage against:</p>
<ul>
<li><strong>Total Insurance Cover: </strong>PKR 30,000</li>
<li><strong>Waiting Period:</strong> 14 days</li>
</ul>
<p><strong>Claims:</strong></p>
<ul>
<li>Make your claim within 30 (thirty) days of the damage or theft/burglary</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>End-to-end support and handholding to claimant</li>
<li>Claim will be settled on market value of the phone screen repair of same make and model</li>
</ul>`,
          type: "insurance",
        }
      ];
    }
  
    getAllItems() {
      return this.items;
    }
  }
  
  export default mobile_insurance;
  